<template>
	<section ref="el" data-component="introduction">
		<div class="g-row title-row">
			<div class="g-col xxl-8 md-10 sm-12 xs-16">
				<h3 class="-title-4 title">
					<SanityContent :value="title" :components="components" />
				</h3>
			</div>
		</div>
		<div v-if="displayImage" class="image-row">
			<picture>
				<source v-if="mobileImage?.url" :srcset="mobileImage.url" media="(max-width: 767px)" />
				<img :width="displayImage.width" :height="displayImage.height" :src="displayImage.url" :alt="displayImage.alt || 'introduction graphic'" />
			</picture>
		</div>
		<div class="g-row features-row">
			<div v-for="(feature, i) in features" :key="i" class="g-col xxl-4 md-5 sm-14 xs-14">
				<p class="-body-medium text">
					<SanityContent :value="feature.text" :components="components" />
				</p>
			</div>
		</div>
	</section>
</template>

<script setup>
import { h } from 'vue'

const props = defineProps({
	title: { type: Array, default: undefined },
	features: { type: Array, default: undefined },
	image: { type: Object, default: undefined },
	imageMobile: { type: Object, default: undefined },
})

const desktopImage = computed(() => props.image || props.imageMobile)
const mobileImage = computed(() => props.imageMobile || props.image)
const displayImage = computed(() => desktopImage.value || mobileImage.value)

const components = {
	block: {
		normal: (_, { slots }) => h('span', { class: 'title-line' }, slots.default?.()),
	},
}

const el = ref(null)
const context = inject('pageContext')

const setup = () => {}
const init = () => {}
onMounted(() => {
	const loader = context?.$page?.loader

	loader.loaded.then(() => setup())
	loader.transitionReady.then(() => init())
})
</script>

<style lang="scss" scoped>
[data-component='introduction'] {
	position: relative;

	margin-top: rs(50, 30);

	.g-row {
		justify-content: center;
	}

	.title-row {
		position: relative;
		z-index: 1;
	}

	.title {
		white-space: pre-line;
		text-align: center;

		& :deep(.title-line) {
			display: block;
			@include inherit-font;

			color: var(--color-neutral-tints-900);
		}

		& :deep(strong) {
			color: var(--color-river-blue-500);
			@include inherit-font;
		}
	}

	.image-row {
		position: relative;
		z-index: -1;
		margin-top: rs(-170, 0);

		picture {
			display: block;
		}

		&::after {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100px;
			background: linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);
		}

		img {
			width: 100%;
			height: auto;
		}
	}

	.features-row {
		margin-top: rs(-58, 0);

		.text {
			position: relative;
			padding-left: rs(20, 20);
			padding-right: rs(32, 20);

			@include max-width($sm) {
				margin-top: rs(24, 24);
			}

			&:after {
				content: '';
				position: absolute;
				top: 0;
				left: 0;
				width: 1.5px;
				height: 100%;

				background-color: var(--color-river-blue-500);
			}

			& :deep(.title-line) {
				display: block;
				@include inherit-font;

				color: var(--color-neutral-tints-400);
			}

			& :deep(strong) {
				color: var(--color-neutral-tints-700);
				@include inherit-font;
			}
		}
	}
}
</style>
